import { SEO_KEYWORD_LANDING_PATHS } from '@/features/seo-keyword-landing/catalog'
import { ROUTES } from '@/navigation/constants'

/**
 * Locale-free ES paths that are prerendered for both locales (hreflang / og:locale:alternate).
 * Prefix-based so LocaleSeoLinks does not import article catalogs.
 */
export function isSsgLocaleFreePath(path: string): boolean {
    if (path === ROUTES.home || path === ROUTES.learn || path === ROUTES.news) return true
    if (path === ROUTES.faqs || path === ROUTES.press) return true
    if (SEO_KEYWORD_LANDING_PATHS.includes(path)) return true
    if (path.startsWith(`${ROUTES.learn}/`) || path.startsWith(`${ROUTES.news}/`)) return true
    if (path.startsWith(`${ROUTES.authors}/`)) return true
    return false
}
